module.exports = __webpack_public_path__ + "img/voucher-edit-bg.b2d505f4.png";